module.exports = __webpack_public_path__ + "img/fail4.ba8fe705.gif";